export const getJSDTeamByIdURL = (ogTeamId = '') => `/jsd-escalator/api/teams/${ogTeamId}`;
export const getJiraOpsTeamUrl = (platformTeamId = '') => `/jira/ops/teams/${platformTeamId}`;
